import { useEffect } from 'react'
import { useRouter } from 'next/router'
import Script from 'next/script'

import { BRAND_ID } from '@/config/brand'

const OPENWIDGET_INIT = `;(function(n,t,c){function i(n){return e._h?e._h.apply(null,n):e._q.push(n)}var e={_q:[],_h:null,_v:"2.0",on:function(){i(["on",c.call(arguments)])},once:function(){i(["once",c.call(arguments)])},off:function(){i(["off",c.call(arguments)])},get:function(){if(!e._h)throw new Error("[OpenWidget] You can't use getters before load.");return i(["get",c.call(arguments)])},call:function(){i(["call",c.call(arguments)])},init:function(){var n=t.createElement("script");n.async=!0,n.type="text/javascript",n.src="https://cdn.openwidget.com/openwidget.js",t.head.appendChild(n)}};!n.__ow.asyncInit&&e.init(),n.OpenWidget=n.OpenWidget||e}(window,document,[].slice))`

const NOSCRIPT_HTML =
  'You need to <a href="https://www.chatbot.com/help/chat-widget/enable-javascript-in-your-browser/" rel="noopener nofollow">enable JavaScript</a> in order to use the AI chatbot tool powered by <a href="https://www.chatbot.com/" rel="noopener nofollow" target="_blank">ChatBot</a>'

const SAIS_CONFIG = {
  organizationId: '86f5368f-36cc-4faa-a9c7-a1c999d23949',
  it: { templateId: '059275b2-e4e8-48f9-8798-2c0102c71105' },
  en: { templateId: '88b095e0-49dc-45b2-8e81-f442089d85d8' }
}

const SaisChatbot = ({ locale }: { locale: string }) => {
  const config = locale === 'it' ? SAIS_CONFIG.it : SAIS_CONFIG.en
  const id = `chatbot-sais-${locale}`

  return (
    <>
      <Script
        id={id}
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `window.__ow = window.__ow || {};
window.__ow.organizationId = "${SAIS_CONFIG.organizationId}";
window.__ow.template_id = "${config.templateId}";
window.__ow.integration_name = "manual_settings";
window.__ow.product_name = "chatbot";
${OPENWIDGET_INIT}`
        }}
      />
      <noscript dangerouslySetInnerHTML={{ __html: NOSCRIPT_HTML }} />
    </>
  )
}

const Chatbot = () => {
  const { locale, pathname } = useRouter()
  const lang = locale ?? 'it'

  useEffect(() => {
    const el = document.getElementById('chat-widget-container')
    if (!el) return
    el.style.display = pathname.startsWith('/auth') ? 'none' : ''
  }, [pathname])

  if (BRAND_ID === 'sais') return <SaisChatbot locale={lang} />

  return null
}

export default Chatbot
